module.exports = __webpack_public_path__ + "static/media/CSO dataset cleanup instructions.35116c8f.txt";